import { tokenAbi, tokenAddress, votesAbi, votesAddress, url } from "../config";
import React, { useEffect, useState } from "react";
import { RotatingLines } from "react-loader-spinner";
import { useAccount, useNetwork, useSigner } from "wagmi";
import { ethers } from "ethers";
import axios from 'axios';

function NewProposals() {

    const { isConnected, address } = useAccount();
    const { chain } = useNetwork()
    const { data: signer, } = useSigner()
    const [approved, setApproved] = useState(false);
    const [loading, setLoading] = useState(false);

    const [proposalDetails, setProposalDetails] = React.useState({
        title: "",
        description: "",
        image: "",
    })

    const checkApproval = async () => {
        const contract = new ethers.Contract(tokenAddress[chain.id], tokenAbi, signer);
        const allowance = await contract.allowance(address, votesAddress[chain.id]);
        if (allowance.gt(0)) {
            setApproved(true);
        }
    }

    const approve = async () => {
        try{
            setLoading(true);
            const contract = new ethers.Contract(tokenAddress[chain.id], tokenAbi, signer);
            const tx = await contract.approve(votesAddress[chain.id], ethers.constants.MaxUint256);
            const res = await tx.wait();
            if (res.status === 1) {
                console.log("Approve success")
                setApproved(true);
            }
        } catch (err) {
            console.error(err);
            if (err.reason) {
                alert(err.reason);
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (isConnected && !chain?.unsupported && signer && address) {
            checkApproval().catch((e) => {
                console.log(e)
            })
        }
    }, [address, signer])

    const createProposal = async () => {
        try {
            setLoading(true);
            const contract = new ethers.Contract(votesAddress[chain.id], votesAbi, signer);
            const tx = await contract.createProposal();
            const result = await axios.post(
                url + '/newProposal',
                {...proposalDetails, hash: tx.hash}
            )
            if (result.status === 200) {
                console.log("recorded proposal")
            }    

            const res = await tx.wait();
            if (res.status === 1) {
                console.log("Proposal created")
                alert("Proposal created")
            }
        } catch (err) {
            console.error(err);
            if (err.reason) {
                alert(err.reason);
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="container">
            <div className="row pb_50 pt_50 createPraposal">

                <div className="col-12 alignCenter ">
                    <h4>Create New Proposal (10,000 FND)</h4>
                    <div className="ml-auto alignCenter">
                        <a href="/" className="btn"><i className="fa-solid fa-arrow-left mr-2"></i> Back</a>

                    </div>
                </div>
                <div className="col-12 ">
                    <form className="formCard ">
                        <div className="form-group">
                            <label>Title</label>
                            <input type="text" name="" onChange={(e)=>setProposalDetails({...proposalDetails, title:e.target.value})} placeholder="Enter your title" className="field  text-white" maxLength={250}></input>
                        </div>
                        <div className="form-group">
                            <label>Description (max 500 characters)</label>
                            <textarea onChange={(e)=>setProposalDetails({...proposalDetails, description:e.target.value})} placeholder="Enter your description" className="field text-white" maxLength={500}></textarea>
                        </div>
                        <div className="form-group">
                            {!approved ? (
                                <button type="button" disabled={loading} className="btn-green ml-2" onClick={() => approve()}>{loading ? <RotatingLines height={20} width={20}></RotatingLines> : "Approve $FND"}</button>
                            ) : (
                                <button disabled={loading} onClick={() => createProposal()} className="btn-green ml-2">{loading ? <RotatingLines height={20} width={20}></RotatingLines> : "Create"}</button>
                            )}
                        </div>
                    </form>
                </div>
            </div>

        </div>
    )
}

export default NewProposals